export const LOGIN_FORM = 'login-form';

export const REPORT_PAYMENT_FORM_NAME = 'report-payment';
export const CREDIT_MEMO_FORM_NAME = 'credit-memo';
export const CLOSE_CASE_FORM_NAME = 'close-case';
export const CONTACT_FORM_NAME = 'contact-form';
export const ON_HOLD_FORM_NAME = 'on-hold';
